var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
import { DATA_CACHE_LOCATION, DATA_CACHE_SIZE, FILE_LOCKING_EXTENSIONS, FORBID_SPECIAL_CHARACTERS, MAX_DOWNLOAD_RATE, MAX_UPLOAD_RATE, MOUNT_POINT_LINUX, MOUNT_POINT_OSX, MOUNT_POINT_WINDOWS, TEAM_CACHE_ENABLED, TEAM_CACHE_LOCATION, } from '@lucidlink/sdk';
export const DELETE_STEPS = {
    ConfirmDelete: 'confirm_delete',
    ConfirmCode: 'confirm_code',
};
export const ALL_SETTINGS = [
    DATA_CACHE_SIZE,
    FILE_LOCKING_EXTENSIONS,
    FORBID_SPECIAL_CHARACTERS,
    MAX_DOWNLOAD_RATE,
    MAX_UPLOAD_RATE,
    MOUNT_POINT_LINUX,
    MOUNT_POINT_OSX,
    MOUNT_POINT_WINDOWS,
    TEAM_CACHE_ENABLED,
    TEAM_CACHE_LOCATION,
];
export const ALL_LOCAL_SETTINGS = [
    DATA_CACHE_SIZE,
    DATA_CACHE_LOCATION,
    FILE_LOCKING_EXTENSIONS,
    FORBID_SPECIAL_CHARACTERS,
    MAX_DOWNLOAD_RATE,
    MAX_UPLOAD_RATE,
    MOUNT_POINT_LINUX,
    MOUNT_POINT_OSX,
    MOUNT_POINT_WINDOWS,
    TEAM_CACHE_ENABLED,
    TEAM_CACHE_LOCATION,
];
export const MOUNT_POINTS = [
    MOUNT_POINT_LINUX,
    MOUNT_POINT_OSX,
    MOUNT_POINT_WINDOWS,
];
export const SETTINGS_NUMBER_INPUT_NAME = 'numberInput';
export const SETTINGS_UNIT_INPUT_NAME = 'unitInput';
export const DEFAULT_LOCAL_CACHE_SIZE = '25 GiB';
export const CACHE_SIZE_UNITS = ['MiB', 'GiB', 'TiB'];
export const CACHE_SIZE_UNITS_OPTIONS = CACHE_SIZE_UNITS.map(_react_refresh_temp_1 = (unit) => ({
    id: unit,
    text: unit,
}));
$RefreshReg$(_react_refresh_temp_1, "CACHE_SIZE_UNITS_OPTIONS$CACHE_SIZE_UNITS.map");
_react_refresh_temp_2 = CACHE_SIZE_UNITS_OPTIONS;
$RefreshReg$(_react_refresh_temp_2, "CACHE_SIZE_UNITS_OPTIONS");
export const CACHE_SIZE_RANGES = {
    LOWER: '100 MiB',
    UPPER: '10 TiB',
};
export const RATE_LIMIT_UNITS = ['KB/s', 'MB/s', 'GB/s'];
export const RATE_LIMIT_UNITS_OPTIONS = RATE_LIMIT_UNITS.map(_react_refresh_temp_3 = (unit) => ({
    id: unit,
    text: unit,
}));
$RefreshReg$(_react_refresh_temp_3, "RATE_LIMIT_UNITS_OPTIONS$RATE_LIMIT_UNITS.map");
_react_refresh_temp_4 = RATE_LIMIT_UNITS_OPTIONS;
$RefreshReg$(_react_refresh_temp_4, "RATE_LIMIT_UNITS_OPTIONS");
export const FILESPACE_SETTINGS_TABS = {
    general: 'general',
    global: 'global',
    local: 'local',
};
export const FILESPACE_SETTINGS_TAB_QUERY_PARAM_KEY = 'settingsTab';
export const FILESPACE_CREATE_FIELD_NAMES = {
    filespaceFormat: 'filespaceFormat',
    name: 'name',
    storageRoleArn: 'storageRoleArn',
    storageCredentialsType: 'storageCredentialsType',
    storageRoleExternalId: 'storageRoleExternalId',
    storageAccessKeyId: 'storageAccessKeyId',
    storageBucket: 'storageBucket',
    storageContinentId: 'storageContinentId',
    storageEndpoint: 'storageEndpoint',
    storageOwner: 'storageOwner',
    storageProviderId: 'storageProviderId',
    storageRegionId: 'storageRegionId',
    storageRegionName: 'storageRegionName',
    storageSecretAccessKey: 'storageSecretAccessKey',
    storageBlockSize: 'storageBlockSize',
    subscriptionType: 'subscriptionType',
};
export const PRODUCTION_STORAGE_PROVIDER = 'AWS';
export const FILESPACE_CREATE_FORM_CASES = {
    LucidlinkStorage: 'lucidlink-storage',
    CustomNoRegions: 'custom-no-regions',
    CustomWithRegions: 'custom-with-regions',
    CustomWithRegionsAndRole: 'custom-with-regions-and-role',
    CustomOther: 'custom-other',
};
export const SUBSCRIPTION_TYPE_CUSTOM = 'custom';
export const BLOCK_SIZES_KIBIBYTE = ['256', '1024', '2048', '4096'];
export const CUSTOM_DEFAULT_BLOCK_SIZE = '256';
export const LUCID_DEFAULT_BLOCK_SIZE = '1024';
